import apiApp from "./index";

const token = localStorage.getItem("UserjwtToken");
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));
// helper: return query param if subTenantId exists
const getSubTenantIdParam = () => {
    if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
        const subTenantId = decodedToken?.subTenantId;
        return subTenantId ? `&subTenantId=${subTenantId}` : "";
    } else if (switched && switchedSubtenant) {
        return `&subTenantId=${switchedSubtenant?.id}`;
    }
    return "";
};

// Helper: build subTenantDTO for request body
const getSubTenantDTO = () => {
  return decodedToken?.isMultitenancy && decodedToken?.subTenantId
    ? { id: decodedToken.subTenantId }
    : null;
};

// Common headers
// const getHeaders = () => ({
//   Authorization: `Bearer ${token}`,
//   "x-Authorization": decodedToken?.tenantApiKey,
// });
const getHeaders = (extraHeaders = {}) => {
  const headers = {
    Authorization: `Bearer ${token}`,
    "x-Authorization": `${decodedToken?.tenantApiKey}`,
  };

  if (
    decodedToken?.roles?.includes("TENANT_ADMIN") ||
    decodedToken?.subTenantId === undefined
  ) {
    headers["tenant-login"] = true;
  }

  // merge additional headers passed at call time
  return { ...headers, ...extraHeaders };
};

const StockAdjustmentLogApi = {
  // Create stock log
  CreateStockAdjustmentLog: (data) => {
    const jsonData = JSON.parse(data);
    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;

    return apiApp
      .post(`/stockAdjustment`, JSON.stringify(jsonData), { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

    // List Products
  getAllStockAdjustments: (page, limit, startAdjustedTimestamp, endAdjustedTimestamp) => {
    const url = `/stockAdjustment?page=${page}&size=${limit}&startAdjustedTimestamp=${startAdjustedTimestamp}&endAdjustedTimestamp=${endAdjustedTimestamp}&sort=desc&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`;
    return apiApp
      .get(url, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },
}

export default StockAdjustmentLogApi;
